/**
 * Detect if computer has been sleeping
 * - a.k.a. has time has skipped more than 60 seconds?
 */

class WakeUpDetector {
	private lastTime: number

	private readonly timer: ReturnType<typeof setInterval>

	private readonly callback: () => void

	/**
	 * Initialize wakeup detector
	 * @param callback Callback to invoke when wake has been detected
	 */
	constructor(callback: () => void) {
		this.lastTime = (new Date()).getTime()
		this.timer = setInterval(this.check.bind(this), 1000)
		this.callback = callback
	}

	/**
	 * Check every seconds to see if time has skipped
	 */
	private check() {
		const current = (new Date()).getTime()
		if (this.lastTime + 60000 < current) {
			this.lastTime = current
			this.callback()
		} else {
			this.lastTime = current
		}
	}

	/**
	 * Stop wakeup detector
	 */
	stop() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	}

	/** Create wakeup detector */
	static create(callback: () => void) {
		return new WakeUpDetector(callback)
	}
}

export default WakeUpDetector
